import { Typography, Box, Grid } from "@mui/material";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";
import Legenda from "./Legenda";
import Card from "./Card";

export default function CardAtivoInativo({ title, subtitle, ativos = 0, inativos = 0, loading }) {
    const fmt = (n) => (n ?? 0).toLocaleString("pt-BR");
    const total = ativos + inativos;
    function StackedBar({ partes, total }) {
        return (
            <Box sx={{ display: "flex", height: 12, borderRadius: 6, overflow: "hidden", bgcolor: COLORS.kpiBg }}>
                {partes.map((p) => (
                    <Box
                        key={p.label}
                        title={`${p.label}: ${fmt(p.valor)}`}
                        sx={{ width: `${total ? (p.valor / total) * 100 : 0}%`, bgcolor: p.cor, transition: "width .4s" }}
                    />
                ))}
            </Box>
        );
    }
    return (
        <Grid item xs={12} md={4}>
        <Card title={title} subtitle={subtitle} loading={loading}>
            <Typography sx={{ fontSize: 28, fontWeight: 700, color: COLORS.tPri }}>{fmt(total)}</Typography>
            <Box sx={{ my: 1.25 }}>
                <StackedBar
                    total={total}
                    partes={[
                        { label: "Ativos", valor: ativos, cor: COLORS.g1 },
                        { label: "Inativos", valor: inativos, cor: COLORS.red },
                    ]}
                />
            </Box>
            <Legenda
                itens={[
                    { label: "Ativos", valor: ativos, cor: COLORS.g1 },
                    { label: "Inativos", valor: inativos, cor: COLORS.red },
                ]}
            />
        </Card>
        </Grid>
    );
}